import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  CompetitorFilterCompetitor,
  CompetitorUpdateCompetitor,
  CompetitorCreateCompetitor,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function CompetitorsAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});
  const navigate = useNavigate();

  let { id, extra } = useParams();

  const start = async () => {
    try {
      if (extra) {
        const CompetitorFilterCompetitorData = await CompetitorFilterCompetitor(
          {
            id: extra,
          }
        );
        if (
          CompetitorFilterCompetitorData.status &&
          CompetitorFilterCompetitorData.status === 200
        ) {
          setForm(CompetitorFilterCompetitorData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (form.isAuto === "") {
      toast.error("وضعیت اتوماتیک بودن رو مشخص کنید");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (extra) {
          const CompetitorUpdateCompetitorData =
            await CompetitorUpdateCompetitor(form);
          if (
            CompetitorUpdateCompetitorData.status &&
            CompetitorUpdateCompetitorData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Competitors/" + id);
          }
        } else {
          const CompetitorCreateCompetitorData =
            await CompetitorCreateCompetitor({
              ...form,
              competitorCategoryId: id,
            });
          if (
            CompetitorCreateCompetitorData.status &&
            CompetitorCreateCompetitorData.status === 200
          ) {
            toast.success("افزودن  مرجع جدید با موفقیت انجام شد");
            navigate("/Panel/Competitors/" + id);
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                className="m-2"
                type="text"
                name="name"
                id="name"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
              <Select
                className="m-2"
                type="text"
                name="isAuto"
                id="isAuto"
                text="اتوماتیک"
                value={form.isAuto || ""}
                onChange={handleChangeSearch}
                option={[
                  { value: true, title: "فعال" },
                  { value: false, title: "غیرفعال" },
                ]}
              />
              <InputCus
                className="m-2"
                type="text"
                name="idAuto"
                id="idAuto"
                text="Id Out"
                value={form.idAuto || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="repeatAuto"
                id="repeatAuto"
                text="هر چند ساعت"
                value={form.repeatAuto || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="description"
                id="description"
                text="توضیحات مخصوص مشتریان خاص"
                value={form.description || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {extra ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompetitorsAE;
